import React, {useState, useCallback} from 'react'
import {
  ModalComponent,
  ModalProps,
  ModalsStateContextProps,
  ModalsActionsContext,
  ModalsStateContext,
} from './ModalsContext'

type Props = {
  children: React.ReactNode
}

function ModalsContextProvider(props: Props) {
  const [state, setState] = useState<ModalsStateContextProps>({modal: null})

  const open = useCallback(function<T>(component: ModalComponent<T>, props: ModalProps<T>) {
    setState(state => ({...state, modal: {component, props}}))
  }, [])

  const close = useCallback(function() {
    setState(state => ({...state, modal: null}))
  }, [])

  return (
    <ModalsActionsContext.Provider value={{open, close}}>
      <ModalsStateContext.Provider value={state}>{props.children}</ModalsStateContext.Provider>
    </ModalsActionsContext.Provider>
  )
}

export default ModalsContextProvider
